import React from "react";
import "./SubscribeInfoModal.css";

export default function SubscribeInfoGenerate({ onClose }) {
  return (
    <div className="subscribe-info-backdrop">
      <div className="subscribe-info-content">
        <button className="subscribe-info-close" onClick={onClose}>
          &times;
        </button>
        <h2>Подпишитесь, чтобы получить возможность генерировать курс.</h2>
      </div>
    </div>
  );
}
